import "./styles/versionPicker.sass";
import { memo } from "react";
import { api } from "@src/utils/axios-instance";
import { useQuery } from "@tanstack/react-query";
import Select from "../Select/Select";
import Loader from "../Loader/Loader";
import { CharacterListVersion, Version } from "@src/types/global";

interface IProps {
    character: CharacterListVersion;
    onClick: (version: Version, character: CharacterListVersion) => void;
}
/**
 * A dialog that queries the backend for a character's versions.
 * The onClick function allows the parent component to decide what to do with the selected version information.
 * @param {Character} character - The character whose information to retrieve
 * @param {function} onClick	- What happens onClick
 */
const VersionPicker = memo(function VersionPicker({
    character,
    onClick,
}: IProps) {
    const fetchData = (): Promise<Version[]> =>
        api
            .get(`/characters/${character.id}/version`)
            .then((res) => res.data.data);

    const query = useQuery<Version[]>({
        queryKey: ["versions", character.id],
        queryFn: fetchData,
        staleTime: 60000
    });
    if (query.isPending) {
        return <Loader />;
    }

    if (query.isError) {
        return <span>Error: {query.error.message}</span>;
    }
    return (
        <div className="version-picker">
            <h3>Select a version for {character.first_name} ?</h3>
            <div className="select__wrapper">
                <Select
                    name="version"
                    options={query.data
                        ?.filter(
                            (version) => version.id !== character.version_id,
                        )
                        .map((version, index) => ({
                            name: version.version_name,
                            id: version.id,
                        }))}
                    onChange={(id: string) => {
                        onClick(
                            query.data.find((version) => version.id == id)!,
                            character,
                        );
                    }}
                ></Select>
            </div>
        </div>
    );
});
export default VersionPicker;
